import type { z } from 'zod';
import type { configOverridesSchema } from '#schemas/config-override/config-overrides-schema.ts';

export type ConfigOverridesFormData = z.input<typeof configOverridesSchema>;

export const configOverridesDefaultValues: ConfigOverridesFormData = {
  definednet: {
    dns: {
      resolver_addrs: '',
      match_domains: '',
      search_domains: '',
    },
  },
  lighthouse: {
    remote_allow_list: [],
    local_allow_list: [],
    serve_dns: '',
    advertise_addrs: '',
    dns: {
      host: '',
      port: null,
    },
    interval: null,
  },
  listen: {
    batch: null,
    read_buffer: null,
    write_buffer: null,
    host: '',
    udp_offloads: '',
  },
  tun: {
    disabled: '',
    dev: '',
    tx_queue: null,
    mtu: null,
    use_offloads: '',
  },
  logging: {
    format: '',
    level: '',
    timestamp_format: '',
  },
  stats: {
    type: '',
    host: '',
    prefix: '',
    namespace: '',
    subsystem: '',
    listen: '',
    path: '',
    interval: null,
    lighthouse_metrics: '',
    message_metrics: '',
  },
  static_map: {
    network: '',
  },
  punchy: {
    delay: null,
    respond_delay: null,
  },
  preferred_ranges: '',
  routines: null,
};
